module.exports = __webpack_public_path__ + "img/Menu.98565778.svg";